<template>

        <div class="container-project-board flex-column">
            <!-- <div class="project-board-scroll-x"> -->
                <div class="row row-headings g-0 w-100 mt-1">
                    <div class="col">
                        <div class="story-heading default">
                            New
                            <span data-bs-toggle="tooltip" data-bs-placement="top" title="" class="count" data-bs-original-title="Unknown">{{getTaskCount('New')}}</span>
                            <add-item :user-story-id="null" type="Issue"></add-item>
                        </div>
                    </div>
                    <div class="col">
                        <div class="story-heading warning">
                            In Progress
                            <span data-bs-toggle="tooltip" data-bs-placement="top" title="" class="count" data-bs-original-title="Unknown">{{getTaskCount('In Progress')}}</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="story-heading">
                            Review
                            <span data-bs-toggle="tooltip" data-bs-placement="top" title="" class="count" data-bs-original-title="Unknown">{{getTaskCount('Review')}}</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="story-heading success">
                            Completed
                            <span data-bs-toggle="tooltip" data-bs-placement="top" title="" class="count" data-bs-original-title="Unknown">{{getTaskCount('Completed')}}</span>
                        </div>
                    </div>
                </div>

                <div>

                    <div v-bind:id="'collapseEpic'+-1" class="collapse show">
                        <div class="row row-user-story g-0" >

                            <div class="col droppable" @drop="dragFinish(null, 'New', $event)" @dragover.prevent @dragenter="dragEnter($event)" @dragleave="dragLeave($event)">
                                <item v-for="item in getByStatusAndFilters('New')" :key="item.id" :item="item"></item>
                            </div>

                            <div class="col droppable"  @drop="dragFinish(null, 'In Progress', $event)" @dragover.prevent @dragenter="dragEnter($event)" @dragleave="dragLeave($event)">
                                <item  v-for="item in getByStatusAndFilters('In Progress')" :key="item.id" :item="item"></item>
                            </div>

                            <div class="col droppable" @drop="dragFinish(null, 'Review', $event)" @dragover.prevent @dragenter="dragEnter($event)" @dragleave="dragLeave($event)">
                                <item v-for="item in getByStatusAndFilters('Review')" :key="item.id" :item="item"></item>
                            </div>

                            <div class="col droppable" @drop="dragFinish(null, 'Completed', $event)" @dragover.prevent @dragenter="dragEnter($event)" @dragleave="dragLeave($event)">
                                <item v-for="item in getByStatusAndFilters(['Completed', 'Resolved'])" :key="item.id" :item="item"></item>
                            </div>
                        </div>

                    </div>


                </div>

            <!-- </div> -->

        <filterDrawer ref="filtersDrawer" />
    </div>



</template>

<script>

    import { mapState, mapActions, mapGetters } from 'vuex'


    import item from '../scrumboard/_item'
    import filterDrawer from './FilterDrawer'
    import addItem from '../scrumboard/_add-item'
    import dragAndDrop from 'mixins/scrumboard/drag-and-drop'
    import boardDrawers from 'mixins/scrumboard/board-drawers'
    import { echo } from 'mixins'

    export default {
        mixins: [dragAndDrop, echo, boardDrawers],
        components: {
            item,
            filterDrawer,
            addItem
        },

        data: function () {
            return {
                loaded: false,
                members: []
            }
        },

        created () {
          this.echoConnect()
        },

        mounted() {
            this.loadData()
        },

        beforeDestroy: function() {
            this.echo.leave(`channel-yodiz-usd-${this.$route.params.user_story_doc_id}`)
            this.echoDisconnect()

            this.$store.dispatch('yodizproject/tasks/clearData', [])
            this.$store.dispatch('yodizproject/stories/clearData', [])
            this.$store.dispatch('yodizproject/effort/clearData', [])
        },

        computed: {

            ...mapState('yodizproject/tasks', {issues: 'list'}),

            ...mapGetters('yodizproject/tasks', {
                getByStatusAndFilters: 'getByStatusAndFilters',
                getCountOfStatus: 'getCountOfStatus'
            })
        },

        methods: {

            ...mapActions('users', {
                getUsers: 'getUsers',
            }),

            ...mapActions('yodizproject/tasks', {
                getIssues: 'getList',
                addItem: 'addFromLocalToList',
                updateItem: 'updateIfLatestVersion',
                deleteItem: 'deleteFromLocalToList'
            }),
            ...mapActions('yodizproject/effort', {
                addEffort: 'addFromLocalToList',
                updateEffort: 'updateFromLocalToList',
                deleteEffort: 'deleteFromLocalToList'
            }),

            joinPresenceChannel() {
                this.echo.join(`channel-yodiz-usd-${this.$route.params.user_story_doc_id}`)
                .listen('Yodiz.newEpicBroadcast', (data) => {
                    this.addEpic([data.epic]);
                })
                .listen('Yodiz.newItemBroadcast', (data) => {
                    if (data.item.id.startsWith('bg-')) {
                        this.addItem([data.item]);
                    }
                })
                .listen('Yodiz.updateItemBroadcast', (data) => {
                    if (data.item.id.startsWith('bg-')) {
                        this.updateItem(data.item);
                    }
                })
                .listen('Yodiz.deleteItemBroadcast', (data) => {
                    if (data.item.id.startsWith('bg-')) {
                        this.deleteItem(data.item.id)
                    }
                })
                .listen('Yodiz.newEffortBroadcast', (data) => {
                    this.addEffort([data.timeEntry]);
                })
                .listen('Yodiz.updateEffortBroadcast', (data) => {
                    this.updateEffort(data.timeEntry);
                })
                .listen('Yodiz.deleteEffortBroadcast', (data) => {
                    this.deleteEffort(data.timeEntry.id)
                })
            },

            connectChannels () {
              this.joinPresenceChannel()
            },

            loadData() {
                this.getUsers();
                this.getIssues({user_story_document_id: this.$route.params.user_story_doc_id}).then(() => {

                    let effort = [];

                    this.issues.forEach(issue => {
                        effort = effort.concat(issue.timeEntries)
                        delete(issue.timeEntries)
                    })

                    this.$store.dispatch('yodizproject/effort/addFromLocalToList', effort).then(() => {
                        effort = []
                    })
                })
            },

            getTaskCount(status){
                //This could be improved as its currently being called for each task status
                return this.getByStatusAndFilters(status).length
            }
        }
    }
</script>

<style >
</style>
